import {IStore} from '../../../shared/shared-models/store/store';

/**
 * Store ids whose processing queues should be read.
 * An explicit list is used as given. Otherwise every store already loaded for the user is used,
 * so this does not read store documents again. The selected store is only a last resort.
 */
export function resolveProcessingQueueStoreIds(
  requestedStoreIds: readonly string[] | undefined,
  userStores: readonly IStore[] | undefined,
  selectedStoreId: string | undefined,
): string[] {
  const requested: string[] = uniqueStoreIds(requestedStoreIds);
  if (requested.length > 0) {
    return requested;
  }

  const loaded: string[] = uniqueStoreIds((userStores ?? []).map((userStore: IStore): string => userStore.storeId));
  if (loaded.length > 0) {
    return loaded;
  }

  return selectedStoreId ? [selectedStoreId] : [];
}

/**
 * Drops blank and repeated store ids while keeping the first-seen order.
 */
export function uniqueStoreIds(storeIds: readonly string[] | undefined): string[] {
  const seen = new Set<string>();
  const unique: string[] = [];
  (storeIds ?? []).forEach((storeId: string): void => {
    if (!storeId || seen.has(storeId)) {
      return;
    }
    seen.add(storeId);
    unique.push(storeId);
  });
  return unique;
}
